const indexTogglesByKey = (togglesArray) => {
    try {
        return togglesArray.reduce((keyValueObject, toggle) => {
          if (toggle && toggle.toggleId !== undefined && toggle.isToggledOn !== undefined) {
            keyValueObject[toggle.toggleId] = toggle.isToggledOn;
          }
          return keyValueObject;
        }, {});
    } catch (error){
      return {};
    }
};

export default indexTogglesByKey;
